export const PHONE = "(416) 856-3410";
export const PHONE_HREF = "tel:+14168563410";
export const ADDRESS = "16310 21 Ave SW, Edmonton, AB T6W 4V5";

const img = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  hero: img("photo-1600585154340-be6161a56a0c", 1800),
  intro: img("photo-1600607687920-4e2a09cf159d"),
  before: img("photo-1504307651254-35680f356dfd", 1600),
  after: img("photo-1600210492486-724fe5c67fb0", 1600),
  edmonton: img("photo-1512917774080-9991f1c4c750"),
};

export const SERVICES = [
  { slug: "framing", title: "Framing", desc: "Structural wood framing for new builds, renovations and home additions.", img: img("photo-1541888946425-d81bb19240f5", 900) },
  { slug: "home-additions", title: "Home Additions", desc: "Expand your living space with professionally planned and built home additions.", img: img("photo-1600047509807-ba8f99d2cdde", 900) },
  { slug: "basement-renovations", title: "Basement Renovations", desc: "Transform unfinished or outdated basement space into comfortable, functional living areas.", img: img("photo-1598928506311-c55ded91a20c", 900) },
  { slug: "kitchen-renovations", title: "Kitchen Renovations", desc: "Create a kitchen designed around your family's needs, layout and lifestyle.", img: img("photo-1556909212-d5b604d0c90d", 900) },
  { slug: "bathroom-renovations", title: "Bathroom Renovations", desc: "Modernize your bathroom with professional renovation and finishing work.", img: img("photo-1552321554-5fefe8c9ef14", 900) },
  { slug: "decks-fencing", title: "Decks & Fencing", desc: "Outdoor structures built to handle Edmonton's changing seasons.", img: img("photo-1605146769289-440113cc3d00", 900) },
  { slug: "painting", title: "Painting", desc: "Interior and exterior painting with professional preparation and finishing.", img: img("photo-1562259949-e8e7689d7828", 900) },
  { slug: "drywall-finishing", title: "Drywall & Finishing", desc: "Professional drywall installation, joint finishing and surface preparation.", img: img("photo-1621905251189-08b45d6a269e", 900) },
  { slug: "basement-waterproofing", title: "Basement Waterproofing", desc: "Help protect your basement from moisture and water infiltration.", img: img("photo-1585704032915-c3400ca199e7", 900) },
];

export const PROJECTS = [
  {
    name: "West Edmonton Basement Renovation",
    location: "West Edmonton",
    tags: ["Basement", "Drywall", "Finishing"],
    img: img("photo-1600607687939-ce8a6c25118c", 1600),
  },
  {
    name: "Edmonton Home Addition",
    location: "Edmonton",
    tags: ["Framing", "Addition", "Exterior"],
    img: img("photo-1600566753086-00f18fb6b3ea", 1200),
  },
  {
    name: "Kitchen Renovation",
    location: "Edmonton",
    tags: ["Kitchen", "Renovation", "Finishing"],
    img: img("photo-1556911220-bff31c812dba", 1600),
  },
];

export const WHY = [
  { title: "Clear Communication", desc: "Know what's happening, what's next and where your project stands." },
  { title: "Quality Workmanship", desc: "We focus on the construction details that matter long after the walkthrough." },
  { title: "Organized Job Sites", desc: "We respect your home and work to keep the job site clean and organized." },
  { title: "Straightforward Process", desc: "From walkthrough to final punch list, expectations remain clear." },
  { title: "Local Experience", desc: "Construction services designed around Edmonton homes and local conditions." },
  { title: "One Point of Contact", desc: "Work directly with the team throughout your project." },
];

export const STEPS = [
  { key: "Discover", desc: "Tell us about your project, goals and what you want to change." },
  { key: "Assess", desc: "We review the property, existing space and project requirements." },
  { key: "Plan", desc: "Establish the scope of work, project requirements and next steps." },
  { key: "Build", desc: "Our team completes the construction and finishing work." },
  { key: "Complete", desc: "We walk through the finished project and review the final details." },
];

export const FAQS = [
  {
    q: "What types of construction projects do you handle?",
    a: "Cando Construction specializes in residential construction: framing, home additions, basement, kitchen and bathroom renovations, decks and fencing, interior and exterior painting, drywall and finishing, and basement waterproofing.",
  },
  {
    q: "Do you provide estimates?",
    a: "Yes. Tell us about your project through the estimate request form or by phone, and we'll follow up to discuss your project and arrange the appropriate next step.",
  },
  {
    q: "Do you handle basement renovations?",
    a: "Yes. Basement renovation and finishing is one of our core services, from framing and drywall through interior finishing.",
  },
  {
    q: "Do you work on home additions?",
    a: "Yes. We plan and build home additions, handling the structural framing through the finished details.",
  },
  {
    q: "Do you handle both interior and exterior work?",
    a: "Yes. Our services cover interior work such as renovations, drywall and painting, as well as exterior work including decks, fencing and exterior painting.",
  },
  {
    q: "What areas do you serve?",
    a: "Cando Construction Services Ltd. is based in southwest Edmonton and works with homeowners throughout Edmonton.",
  },
  {
    q: "How do I start a project?",
    a: "Contact Cando Construction to discuss your project. Request a project estimate through the form or call us, and we'll arrange the appropriate next step.",
  },
];

export const PROJECT_TYPES = [
  "Framing",
  "Home Addition",
  "Basement Renovation",
  "Kitchen Renovation",
  "Bathroom Renovation",
  "Deck / Fencing",
  "Painting",
  "Drywall / Finishing",
  "Waterproofing",
  "Other",
];

export const SERVICE_ROUTES = {
  "framing": "/framing-contractor-edmonton",
  "home-additions": "/home-additions-edmonton",
  "basement-renovations": "/basement-renovations-edmonton",
  "kitchen-renovations": "/kitchen-renovations-edmonton",
  "bathroom-renovations": "/bathroom-renovations-edmonton",
  "decks-fencing": "/decks-fencing-edmonton",
  "painting": "/painting-contractor-edmonton",
  "drywall-finishing": "/drywall-finishing-edmonton",
  "basement-waterproofing": "/basement-waterproofing-edmonton",
};
